export const environment = {
  production: false,
  hmr: false,
  urlAPI: 'https://dev-api.myposventa.es/api/',
  urlWeb: 'https://dev.myposventa.es/',
  blobPublic: 'https://blobrenault.blob.core.windows.net/dev-renault-marketing-public/',
  authority: 'https://sso-uat.renault.com/oauth2/austwoeshbCkPJyw1416',
  clientId: 'irn-74472_uat_pkce_oa64cskmm304',
  useSSO: true,
  issueTrackerKey: '935dd73d-1c01-486c-937a-bfd421c20fec',
  issueTrackerUrl: 'https://dev-issue-tracker.lnkgs.es/',
  urlApiSurvey:'https://dev-api-simsurvey.lnkgs.es/api/',
  chatbotKey: 'Tp7gGR0PruYH8U39pw19cgaUgnY29-9H8eyQodIY3GyAPJClyDvE0rnf_FI',
  chatbotUrl: 'https://dev-chatbot.lnkgs.es/',
  urlWebRenaultManager:'https://dev-rm.lnkgs.es/',  
};
